const AppInfo = {
    version: '5.0.4',
    bannerUrl: 'https://biblestudytogether.com/home-banner/info.json',
}

export default AppInfo;